// @flow
import React from "react";
import type { IconProps } from "../";

type Props = {
  ...IconProps,
  className?: string,
  onClick?: () => void
};

export default function ModeDark({
  width = "13px",
  fill = "currentColor",
  ...props
}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12.844 14.471"
      fill={fill}
      width={width}
      {...props}
    >
      <path
        d="M4.9,9.043a7.287,7.287,0,0,1,.984-3.662.341.341,0,0,0-.369-.508A7.346,7.346,0,1,0,12.757,16.95a.339.339,0,0,0-.268-.563c-.079,0-.159.005-.239.005A7.349,7.349,0,0,1,4.9,9.043Z"
        transform="translate(0 -4.862)"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Tools/ModeDark.js